import Vue from 'vue';
import { httpPost, httpGet } from '../../assets/scripts/http';

// 按钮
const GridRenderCellButtons = {
  render(h) {
    const { buttons } = this.params;
    const vm = this;
    return h('div', { style: { textAlign: 'center', display: 'flex' } }, [
      buttons.map(item => {
        const { props = {} } = item;
        let btnParams = props;
        if (typeof props === 'function') {
          btnParams = props(vm.params);
        }
        return h(
          'znl-button',
          {
            props: { type: 'text', ...btnParams },
            on: {
              click() {
                item.click(vm.params);
              }
            }
          },
          typeof item.text === 'function' ? item.text(vm.params) : item.text
        );
      })
    ]);
  }
};
// 公司简称，网址
const GridCellElPopover = {
  render(h) {
    const params = this.params;
    return h('span', [
      h(
        'el-popover',
        {
          props: {
            width: 'auto',
            trigger: 'hover',
            placement: 'left',
            'popper-class': 'companyBusinesscard-popper'
          }
        },
        [
          h('div', { class: 'companyBusinesscard' }, [
            h('div', { class: 'title' }, params.data.CompanyName),
            h('div', { class: 'row' }, [
              h('span', { class: 'label' }, '网址：'),
              h(
                'a',
                {
                  attrs: {
                    href: /^(http)/.test(params.data.Website)
                      ? params.data.Website
                      : `https://${params.data.Website}`,
                    target: '_blank'
                  }
                },
                params.data.Website
              )
            ])
          ]),
          h(
            'span',
            {
              slot: 'reference',
              class: 'HoverCommon',
              style: {
                color: '#28c'
              },
              on: {
                click() {
                  if (params.click) {
                    params.click(params);
                  }
                }
              }
            },
            params.data.CompanyAlias || params.data.CompanyName
          )
        ]
      )
    ]);
  }
};
// 类别
const GridCellGradeDiscount = {
  render(h) {
    const params = this.params;
    let Grade = '--';
    switch (params.data.Grade) {
      case 1:
        Grade = 'A';
        break;
      case 2:
        Grade = 'B';
        break;
      case 3:
        Grade = 'C';
        break;
      default:
        Grade = '--';
        break;
    }
    return h(
      'span',
      {
        class: 'linebutton',
        on: {
          click() {
            if (params.click) {
              params.click(params);
            }
          }
        }
      },
      [
        h('span', Grade),
        h('span', { class: 'center-line' }, '/'),
        h(
          'span',
          `${
            params.data.GradeDiscount
              ? `${(params.data.GradeDiscount * 10).toFixed(1)}折`
              : '--'
          }`
        )
      ]
    );
  }
};
// 日志
const GridRenderCellLog = {
  render(h) {
    const { params } = this;
    const { data } = params;
    const { OrderNo } = this.params.data;
    const vm = this;
    function setOrderRemarkAsync(OrderNo, Remark) {
      httpPost('shareStock/setOrderRemarkAsync', {
        OrderNo,
        Remark
      }).then(res => {
        if (res.Code === 0) {
          vm.$succMess('保存成功');
        }
      });
    }
    return h('span', [
      h(
        'el-popover',
        {
          props: {
            width: 280,
            trigger: 'hover',
            placement: 'left-end',
            'popper-class': 'GridRenderCellLog-popper'
          },
          on: {
            show() {
              // if (!params.data.RemarkOrderHistory) {
              httpGet('shareStock/getOrderHistoryAsync', {
                param: OrderNo
              }).then(res => {
                if (res.Code === 0) {
                  data.RemarkOrderHistory = res.Data.filter(
                    item => item.Status !== 3 || item.Status !== 6
                  );
                }
              });
            }
            // }
            // hide() {
            //   data.RemarkIsEdit = false;
            // }
          }
        },
        [
          h('ul', { class: 'GridRenderCellLog' }, [
            data.RemarkOrderHistory
              ? data.RemarkOrderHistory.map(item => {
                  let StatusStr = '';
                  switch (item.Status) {
                    case 1:
                      StatusStr = '您有新的订单';
                      break;
                    case 2:
                    case 3:
                    case 6:
                      StatusStr = '订单正在处理中';
                      break;
                    case 4:
                      StatusStr = '交易成功';
                      break;
                    case 5:
                      StatusStr = '订单取消';
                      break;
                    default:
                      break;
                  }
                  return h('li', { class: 'GridRenderCellLog-row clearfix' }, [
                    h('span', { class: 'pull-left time' }, item.CreateTime),
                    h('span', { class: 'pull-left Remark' }, [
                      h(
                        'span',
                        item.OperatorRole === 1 ? StatusStr : item.Remark
                      ),
                      h('span', {
                        class:
                          item.OperatorRole === 1
                            ? 'OperatorRole system'
                            : 'OperatorRole nosystem'
                      })
                    ])
                  ]);
                })
              : null,
            h('li', { class: 'clearfix' }, [
              !data.RemarkIsEdit &&
                h(
                  'znl-button',
                  {
                    class: 'pull-left',
                    on: {
                      click() {
                        data.RemarkIsEdit = true;
                        vm.$nextTick(() => {
                          if (vm.$refs.EditInput) {
                            vm.$refs.EditInput.handleFocus();
                          }
                        });
                      }
                    }
                  },
                  '添加备注'
                ),
              data.RemarkIsEdit &&
                h('div', { class: 'clearfix' }, [
                  h(
                    'znl-button',
                    {
                      class: 'pull-left',
                      height: 26,
                      on: {
                        click() {
                          setOrderRemarkAsync(
                            data.OrderNo,
                            data.RemarkEditInputValue
                          );
                          data.RemarkIsEdit = false;
                        }
                      }
                    },
                    '保存'
                  ),
                  h('znl-input', {
                    props: { border: true, width: 150, height: 26 },
                    ref: 'EditInput',
                    on: {
                      input(value) {
                        data.RemarkEditInputValue = value;
                      },
                      keydown(event) {
                        if (event.keyCode === 13) {
                          setOrderRemarkAsync(
                            data.OrderNo,
                            data.RemarkEditInputValue
                          );
                          data.RemarkIsEdit = false;
                        }
                      }
                    }
                  })
                ])
            ])
          ]),
          h(
            'span',
            {
              slot: 'reference',
              class: 'HoverCommon',
              style: {
                color: '#28c'
              }
            },
            '备注日志'
          )
        ]
      )
    ]);
  }
};
Vue.component('GridRenderCellButtons', GridRenderCellButtons);
Vue.component('GridCellElPopover', GridCellElPopover);
Vue.component('GridCellGradeDiscount', GridCellGradeDiscount);
Vue.component('GridRenderCellLog', GridRenderCellLog);
